import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FPNewsSider from './fpNewsSider';
import FPNews from './fpNews';

class FinanceAndPe extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { fpNewsSiderData, fpNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <FPNewsSider content={fpNewsSiderData} />
                <FPNews content={fpNewsData} />
            </div>
        );
    }
}

export default errorBoundary(FinanceAndPe);
